export const T = {
  en_GB: {
    subProcessor: "Sub-processor",
    terms: "Terms",
    status: "Status",
    security: "Security",
    documentation: "Documentation",
  },
  nb_NO: {
    subProcessor: "Underleverandør",
    terms: "Vilkår",
    status: "Status",
    security: "Sikkerhet",
    documentation: "Dokumentasjon",
  },
} as const;
